angular.module("ainapp")
    .controller("usersController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Users";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }



            $scope.Init = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                $scope.UserRoles = [];

                MainService.UserRolesInDropdown().then(function (response) {
                    if (response.data) {
                        $scope.UserRoles = response.data;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });

                $scope.Employees = [];
                MainService.EmployeesInNewUserDropdown().then(function (response) {
                    if (response.data) {
                        $scope.Employees = response.data;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });

                $scope.User = {
                    UserName: "",
                    UserRoleId: "",
                    EmployeeId: "",
                    Password: "",
                    CPassword: "",
                    IsSkip: false,
                }

            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.UsersInGrid(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            UserName: {
                                type: "string",
                                editable: false,
                            },
                            "UserRole.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Employee.Name": {
                                type: "string",
                                editable: false,
                            },
                            IsBlocked: {
                                type: "boolean",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {
                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "Employee.Name",
                        title: "Employee",
                        },
                    {
                        field: "UserName",
                        title: "User Name",
                        },
                    {
                        field: "UserRole.Name",
                        title: "User Role",
                        },
                    {
                        field: "IsBlocked",
                        title: "Status",
                        template: "<p ng-if='dataItem.IsBlocked'>Blocked</p><p ng-if='!dataItem.IsBlocked'>Active</p>"
                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm '  ng-click='Block(dataItem)'>Block/Unblock</button>  ",
                        width: '150px'
                        },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.Block = function (data) {
                $scope.SelectedDataForDelete = data;
                $("#deleteModal").modal("show");
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.BlockUser($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success("Success");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }


            $scope.Edit = function (data) {
                $scope.User = data;
                $scope.Employees.push(data.Employee);
            }

            $scope.AddData = function () {
                if ($scope.User.EmployeeId == "") {
                    toastr.warning("Select Employee");
                } else if ($scope.User.UserName == "") {
                    toastr.warning("Enter User Name");
                } else if ($scope.User.UserRoleId == "") {
                    toastr.warning("Select Role");
                } else if ($scope.User.Password == "") {
                    toastr.warning("Enter Password");
                } else if ($scope.User.CPassword == "") {
                    toastr.warning("Enter Confirm Password");
                } else if ($scope.User.Password != $scope.User.CPassword) {
                    toastr.warning("Password Not Matching");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.SaveUser($scope.User).then(function (response) {
                        if (response.data) {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success("Success");
                            $scope.Init();
                        } else {
                            toastr.error("Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }
            }

        }])
